export const baseURL = "https://dev.casino.bychance.social/";
export const adminBaseURL = "https://dev.admin.bychance.social/";
export const key = "oMX?fr9rk_XcH67]B,^G[@Wpz:-zkP]D";